import { KeyValue } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faClose, faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { DemographicsGroup, IQuestionTypeConfig, QuestionTypeConfig } from '../../models/question-type-config.constants';

@Component({
  selector: 'empathy-question-type-picker',
  templateUrl: 'question-type-picker.component.html',
  styleUrls: ['./question-type-picker.component.scss', './_question-type-picker-theme.component.scss']
})
export class QuestionTypePickerComponent implements OnInit {
  selectedType$ = signal<QuestionType | DemographicsGroup | 'vault'>(QuestionType.SingleChoice);
  selectedFromLibrary$ = signal<Question[]>([]);
  selectedTypeConfig$ = computed<IQuestionTypeConfig>(() => QuestionTypeConfig[this.selectedType$()]);

  questionTypeConfig = QuestionTypeConfig;

  faClose = faClose;
  faBookmark = faBookmark;

  constructor(private dialogRef: MatDialogRef<QuestionTypePickerComponent>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-question-picker__dialog');
  }

  onAddFromLibrary(): void {
    this.dialogRef.close(this.selectedFromLibrary$());
  }

  onClose(): void {
    this.dialogRef.close();
  }

  originalOrder = (_a: KeyValue<string, IQuestionTypeConfig>, _b: KeyValue<string, IQuestionTypeConfig>): number => 0;
}
